require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./accrditation-institutionelle-et-des-programmes-0-2-0-1.json") })
        }
      }, "path---accrditation-institutionelle-et-des-programmes-0-2-0-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---accrditation-institutionelle-et-des-programmes-0-2-0-1!./.cache/json/accrditation-institutionelle-et-des-programmes-0-2-0-1.json
// module id = 312
// module chunks = 231608221292675